export enum EnumRoutes {
  REPORT_ROUTE = '/report/:externalId',
  SESSION_ROUTE = '/session/:sessionGuid',
}
